var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5695 47.9035C37.8861 48.5869 36.778 48.5869 36.0946 47.9035L17.4279 29.2368C16.7445 28.5534 16.7445 27.4453 17.4279 26.7619L36.0946 8.09524C36.778 7.41183 37.8861 7.41183 38.5695 8.09524C39.2529 8.77866 39.2529 9.8867 38.5695 10.5701L21.1402 27.9993L38.5695 45.4286C39.2529 46.112 39.2529 47.22 38.5695 47.9035Z",
    fill: "#000928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.738f0b3244c2c9be3345323bd4ce0f91.svg";
export { ForwardRef as ReactComponent };